<template>
  <div class="history-chart">
    <div class="tabs">
      <el-tabs v-model="mediumActive.mediumStr" @tab-click="mediumSwitch" >
        <!-- 介质选项卡-->
        <el-tab-pane
          v-for="(mediumItem, index) in this.medium"
          :name="mediumItem.MediumStr"
          :key="index"
          :label="mediumItem.mediumId"
          ref="tabPane"
          :disabled="!(mediumItem.selectMedium)"
        >
          <!--介质名称-->
          <span slot="label" :class="[{noTab_label:!mediumItem.selectMedium},'tab_label']" >
            <span :class="[{noTab_label:!mediumItem.selectMedium}]">{{ mediumItem.MediumStr }}</span>                         
            <!-- <span class="iconfont">&#xe617;</span> -->
            <img class="icon" v-bind:src="baseUrl + '/img/' + mediumItem.Icons" />
          </span>
          
        </el-tab-pane>
      </el-tabs>
      <!--站点筛选-->
      <div class="sites-select" @click="dialogVisible = true">
        站点筛选
        <i class="el-icon-caret-bottom"></i>
      </div>
      <!--菜单栏-->
      <div class="menu">
        <el-form :inline="true" >
          <el-form-item label="开始时间">
            <!--日期-->
            <el-date-picker
              v-model="start_date"
              type="date"
              class="start_date date-input"
              placeholder="开始日期">
            </el-date-picker>
            <!--时间-->
            <el-time-select
              v-model="start_time"
              class="start_time time-input"
              placeholder="请选择">
            </el-time-select>
          </el-form-item>
  
          <el-form-item label="结束时间">
            <!--日期-->
            <el-date-picker
              v-model="end_date"
              type="date"
              class="end_date date-input"
              placeholder="开始日期">
            </el-date-picker>
            <!--时间-->
            <el-time-select
              v-model="end_time"
              class="end_time time-input"
              placeholder="请选择">
            </el-time-select>
          </el-form-item>

          <el-form-item label="选择预设时间">
            <el-select placeholder="预设时间" v-model="time_range" class="time_range" @change="timeRangeChange">
              <el-option label="自定义" value="custome"></el-option>
              <el-option label="最近一天" value="day"></el-option>
              <el-option label="最近一周" value="week"></el-option>
              <el-option label="最近一月" value="month"></el-option>
              <el-option label="最近一年" value="year"></el-option>
            </el-select>
          </el-form-item>

          <!--最大行数-->
          <!-- <el-form-item label="最大行数" class="maxrowcount">
            <el-input type="number" v-model.number="maxRowCount" autocomplete="off"></el-input>
          </el-form-item> -->

          <el-button plain type="primary" class="menu-btn" @click="searchHistoryChartData()">
            查询
          </el-button>
        </el-form>
      </div>

      <!-- 图表列表-->
      <!-- <ul class="chartList infinite-list" v-if="Object.keys(historyData).length>0">
        <li class="chart-wrap" v-for="(historyDataItem,index) in historyData" :key="index">
          <chart :sitedata="historyDataItem"></chart>
        </li>
      </ul> -->
      <ul class="chartList infinite-list" v-if="historyPageData&&Object.keys(historyPageData).length>0">
        <li class="chart-wrap" v-for="(historyDataItem,index) in historyPageData" :key="index">
          <chart :sitedata="historyDataItem" v-if="historyDataItem" ref="historychartDom"></chart>
        </li>
      </ul>
      <div v-else class="chartList infinite-list blank">
        暂无数据
      </div>
       <!--分页-->
      <el-pagination v-if="page.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-sizes="page.pagesizes"
          :page-size="page.size"
          layout="prev, pager, next, jumper,sizes,total"
          :total="page.total">
      </el-pagination>
    </div>

    <!-- 站点筛选--dialog -->
    <siteselect :show.sync="dialogVisible" v-if="sites&&sites.siteList" v-on:siteSelectCompleted="siteSelectCompleted"></siteselect>
  </div>
</template>
<script>
import SiteSelect from "@components/SiteSelect";// 站点筛选组件
import Chart from "./Chart"; // 蒸汽图表组件
import {getHistoryChart} from "@api/historyChart";

export default {
  name: "historyChart",
  data() {
    return {
      baseUrl: this.$store.state.assetsUrl, // 基础请求路径
      selectSiteList:{}, // 站点选择的列表,{siteId:siteContent}
      sites: null, // 站点数据，包括站点mediumList、siteLevel、groupList、siteList
      medium: {}, // 介质类型对象，为上面的mediumList,包括介质编号及其名称
      siteList: [], //站点列表数据，为sites钟的siteList内容，站点的编号和相关的属性信息

      dialogVisible: false, //站点筛选dialog

      mediumActive:{
        mediumStr:"",
        mediumId:"",
      }, // 选中的介质名称及其编号

      start_date:'', //开始日期
      end_date:'', // 结束日期
      start_time:'', // 开始时间
      end_time:'', // 结束时间
      time_range:"custome", // 时间范围下拉框
      maxRowCount:300, // 最大行数

      historyDataList:{}, // 历史图表数据

      page:{ // 分页参数
          total:0,
          size:4,
          current:1,
          content:[], // 当前页内容
          allsites:[], // 全部站点数组
          pagesizes:[10, 20, 30, 40,100]
      },
      mediumSitePage:{}, // 全部介质的分页数据

      timeoutMessage:null, // 提示框
      timeoutId:null, // 定时器id

      chartClear:false,// 是否清除chart
    };
  },
  mounted() {
    this.$nextTick(() => {
      //echarts图表
      // this.drawLine();
      this.getSiteListData();
    });
  },
  computed:{
    // 用户配置数据
    configList(){
      return this.$store.getters.configList;
    },
    // 站点数据
    sites_config(){
      return this.$store.getters.getSitesConfigByPage();
      // return this.$store.getters.sites_config;
    },
    // 历史数据
    historyData(){
      return this.historyDataList[this.mediumActive.mediumId]?this.historyDataList[this.mediumActive.mediumId]:[];
    },
    // 历史分页数据
    historyPageData(){
      return this.page.content;
    }
  },
  //定义筛选组件
  components: {
    siteselect: SiteSelect,// 站点筛选组件
    chart:Chart, //蒸汽图表组件
  },
  methods: {
   // 获取站点配置
   async getSiteListData() {
      //接入接口，获取数据
      let data = this.sites_config;
      this.sites =  data;
      // 设置介质类型
      let tempMedium = data.mediumList;    
      //将介质编号添加到对象中去
      for (let mediumId in tempMedium) {
        if(mediumId!=254){  // 虚拟站点不参与曲线数据展示
          let mediumItem=tempMedium[mediumId];
          mediumItem.mediumId = mediumId;
          this.medium[mediumId]=mediumItem;
        }

      }
      // //设置站点列表的数据
      this.siteList = data.siteList;
      this.getSelectedSites(this.siteList);      

      // 显示第一个表头
      let init_mediumId=Object.keys(this.medium)[0];
      //设置选中的介质名称及其编号
      this.mediumActive.mediumStr=this.medium[init_mediumId].MediumStr;
      this.mediumActive.mediumId=init_mediumId;

      // 初始化开始时间和结束时间
      let config  = this.configList;
      let firstToData= config.history_time.startTimeForCustom; // 开始日期
      // 返回的时间可能是这样的20-11-02 09:22，没有前面的年份，所以需要进行处理
      // 至于为什么返回了这么样的数据，还是因为历史原因
      if(firstToData.substr(0,firstToData.indexOf("-")).length<4){
        firstToData=20+firstToData;
      }
      this.start_date= this.$moment(firstToData).format('yyyy-MM-DD'); // 开时日期
      this.start_time=this.$moment(firstToData).format('HH:mm'); // 开始时间

      // 格式化结束日期和时间
      let endToData =config.history_time.endTimeForCustom; // 结束日期
      if(endToData.substr(0,firstToData.indexOf("-")).length){
        endToData=20+endToData;
      }
      this.end_date= this.$moment(endToData).format('yyyy-MM-DD'); // 开时日期
      this.end_time=this.$moment(endToData).format('HH:mm'); // 开始时间

      // 分块获取历史曲线数据
      this.chunckLoadData(init_mediumId,1,4);
    },
    // 获取选择站点信息
    getSelectedSites(siteList){
      //遍历全部站点，筛选出已被选中的站点
      // 清空数据
      for(let mediumId in this.mediumSitePage){
        this.mediumSitePage[mediumId]={
          total:0,
          size:10,
          current:1,
          allsites:[],
          content:[],
        }
      }

      //存放选中的数据
      var selectSiteList = {};
      for (let groupId in siteList) {
        let groupSites = siteList[groupId];
        for (let siteId in groupSites) {
          //拿到对应单个站点数据
          let siteItem = groupSites[siteId];
          if (siteItem.now == true) {
            selectSiteList[siteId]=siteItem;
          }else{
            continue;
          }

          // 将相应的介质以数组的方式放到mediumSitePage中，为了进行分页的获取
          // {0:[],1:[]}
          if(!this.mediumSitePage[siteItem.MediumType]){
            this.mediumSitePage[siteItem.MediumType]={
              total:0,
              size:10,
              current:1,
              allsites:[],
              content:[],
            };
          }
          this.mediumSitePage[siteItem.MediumType].allsites.push(siteItem); // 全部站点数组
          this.mediumSitePage[siteItem.MediumType].total+=1;
          this.mediumSitePage[siteItem.MediumType].content=[]; // 清空站点数组内容
        }
      }
      // 保存获取到的选中站点的值
      this.selectSiteList=selectSiteList;
    },

    // 获取站点的历史数据
    async getHistoryChartData(siteid){
      // 获取开始和结束时间
      let start_dt = this.$moment(this.start_date).format("yyyy-MM-DD")+" "+this.start_time;// 拼接开始时间
      let end_dt = this.$moment(this.end_date).format("yyyy-MM-DD")+" "+this.end_time;// 拼接结束时间

      // 判断时间是否符合要求
      if(!this.$moment(start_dt).isBefore(end_dt)){
        this.$message({
          message:"开始时间应该早于结束时间",
          type:"warning"
        });
      }else{
        // 获取当前选中的介质编号
        let activeMediumId=this.mediumActive.mediumId;
        let currentSite=this.selectSiteList[siteid]; //当前ajax的站点信息
        // 如果当前选中的介质类型和当前选中的站点类型不匹配，不进行数据处理,丢弃相关内容
        if(!currentSite||(activeMediumId!=currentSite.MediumType)){
          return;
        }
        // 获取站点编号
        let data =await getHistoryChart(start_dt,end_dt,siteid,activeMediumId); // 请求历史数据
        if(data.status!==500){
          // 渲染数据内容
          /**
           * this.historyDataList中保存的是分介质类型的站点数据和曲线数据
           */
          if(!this.historyDataList[activeMediumId]){
             this.$set(this.historyDataList,activeMediumId,{});
          }
          if(!this.historyDataList[activeMediumId][siteid]){
            this.$set(this.historyDataList[activeMediumId],siteid,currentSite);
          }

          // 更新数据值
          this.$set(this.historyDataList[activeMediumId][siteid],"historychart",data);
          // this.historyDataList[activeMediumId][siteid].historychart=data;
        }
      }   
    },
    // 获取分页信息
    getHistoryPage(mediumId,current,size){
      let tempPageSites=this.mediumSitePage[mediumId];
      current=current||tempPageSites.current;
      size=size||tempPageSites.size;

      // 获取当前页中的数据内容
      let tempPageArray=tempPageSites.allsites;
      let prepage=(current-1)<0?0:(current-1); // 前一页
      let startSiteIndex=prepage*size;
      let endSiteIndex=current*size>tempPageArray.length?tempPageArray.length:current*size;
      let content=tempPageArray.slice(startSiteIndex,endSiteIndex);

      let tempPage={
        total:tempPageArray.length,
        size:size,
        current:current,
        content:content,
        pagesizes:[4,10,20,40,100]
      };
      // 修改当前分页信息
      this.page=tempPage;

      //保存当前介质的分页信息
      this.mediumSitePage[mediumId]=this.mediumSitePage[mediumId]||{};
      this.mediumSitePage[mediumId]=Object.assign(this.mediumSitePage[mediumId],tempPage);

    },
    // 分块获取历史数据
    async chunckLoadData(mediumid,page,size){
      var that=this;
      that.getHistoryPage(mediumid,page,size);
      // 获取当前的分页以及分页数据
      let tempPage=this.page;
      let content=tempPage.content;

      if(content.length>0){
        // 执行获取历史数据的方法
        this.getHistoryChartData(content[0].SiteNo);
        // 从数组开头延迟获取数据，这样每次只请求一组数据，避免大量的数据请求，卡死页面
        this.setTimeoutGetData(content,1);
      }
    },
    // 延迟获取数据
    setTimeoutGetData(array,index){
      let that=this;
      // 显示提示框
      if(!this.timeoutMessage){
        this.timeoutMessage=that.$message({
            message: '由于数据量较大，数据会持续加载，请耐心等候',
            type: 'warning',
            duration:0 // 不自动关闭
        });
      }      
      // 对数据进行延迟获取
      if(index<array.length){
        let siteItem=array[index];
        let siteId=siteItem.SiteNo;
        let mediumid=siteItem.MediumType;
        this.timeoutId=setTimeout(()=>{
            // 如果数据不存在，则进行请求
            if(!that.historyDataList[mediumid]||
            !that.historyDataList[mediumid][siteId]||
            !that.historyDataList[mediumid][siteId].historychart){
              that.getHistoryChartData(siteId);
            }
            // 获取下一个数据
            index+=1;
            that.setTimeoutGetData(array,index);
        },3000)
      }else{
        // 清空定时器和提示框
        this.clearWindow();
      }
    },
    // 清空定时器和提示框
    clearWindow(){
      // 关闭提示框
      if(this.timeoutMessage){
        this.timeoutMessage.close();
        this.timeoutMessage=null;
      }
      // 关闭定时器
      if(this.timeoutId){
        clearTimeout(this.timeoutId);
        this.timeoutId=null;
      }
    },

    // 介质类型切换
    mediumSwitch(tab){
      // 设置选中的介质编号和名称
      let mediumId=tab.label;
      this.mediumActive.mediumStr=tab.name;
      this.mediumActive.mediumId=mediumId;

      // 清空定时器,清理数据等
      this.clearWindow();

      // 清空子节点的内容
      let childArray=this.$refs.historychartDom;
      if(childArray){
        for(let child of childArray){
          child.disposeEchart();
        }
      }

      // 分块获取历史曲线数据
      this.chunckLoadData(mediumId,1,4);
    },
  
    // 分页的大小改变
    handleSizeChange(val){
       // 获取当前选中的介质编号
      let activeMediumId=this.mediumActive.mediumId;
      // 清空定时器,和提示
      this.clearWindow();
      // 清空子节点的内容
      let childArray=this.$refs.historychartDom;
      if(childArray){
        for(let child of childArray){
          child.disposeEchart();
        }
      }
      // 清空数据
      this.historyDataList[activeMediumId]={};
      // 分批次获取数据
      this.chunckLoadData(activeMediumId,1,val);
    },
    // 分页页码改变
    handleCurrentChange(current){
      // 获取当前选中的介质编号
      let activeMediumId=this.mediumActive.mediumId;
      // 清空定时器,和提示
      this.clearWindow();

      // 清空子节点的内容
      let childArray=this.$refs.historychartDom;
      if(childArray){
        for(let child of childArray){
          child.disposeEchart();
        }
      }
      // 清空数据
      this.historyDataList[activeMediumId]={};
      // 分批次获取数据
      this.chunckLoadData(activeMediumId,current);
    },
    // 查询历史曲线数据
    searchHistoryChartData(){
      // 获取当前选中的介质编号
      let activeMediumId=this.mediumActive.mediumId;

      // 清空定时器,和提示
      this.clearWindow();

      // 清空数据
      this.historyDataList[activeMediumId]={};
      // 分批次获取数据
      this.chunckLoadData(activeMediumId,1);
    },

    // 预设时间改变
    timeRangeChange(val){
      // 获取当前时间
      let nowTime=this.$moment();
      let startTime=nowTime;

      // 格式化结束日期和时间
      this.end_date=nowTime.format('yyyy-MM-DD'); // 开时日期
      this.end_time=nowTime.format('HH:mm'); // 开始时间
      switch (val){
        case "day":
          startTime=nowTime.add(-1,'day');
          break;
        case "week":
          startTime=nowTime.add(-1,'week');
          break;
        case "month":
          startTime=nowTime.add(-1,'month');
          break;
        case "year":
          startTime=nowTime.add(-1,'year');
          break;
        default:
          startTime=nowTime.add(-1,'day');
          break;
      }
      this.start_date= startTime.format('yyyy-MM-DD'); // 开时日期
      this.start_time=startTime.format('HH:mm'); // 开始时间
    },
    // 站点选择完成
    siteSelectCompleted(selectedSites){
      // 清空定时器和提示框
      this.clearWindow();

      // 更新选中的站点数据
      this.getSelectedSites(selectedSites);

      // 查询数据
      this.searchHistoryChartData();
    }
  },
  // 销毁之前
  beforeDestroy(){
    // 清空定时器和提示框
    this.clearWindow();
  }
};
</script>
<style lang="scss">
.history-chart{
  .tabs {
    padding-left: 10px;
    background: #fff;

    .el-tabs__header {
      padding-right: 34px;
      background: white;
      height: 50px;
      line-height: 51px;
      margin:0;
    }
    /**介质图标 */
    .icon {
      width: 30px;
      height: 30px;
      vertical-align: middle;
      margin-left: 5px;
    }
    // 介质标题
    .tab_label {
      display: inline-block;
      min-width: 100px;
      text-align: center;
      font-size: 18px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }

    /**站点筛选按钮 */
    .sites-select{
      display: inline-block;
      margin-right: 10px;
      position:absolute;
      right: 0;
      top:15px;
    }

    /**图表列表 */
    .chartList{
      display: flex;
      flex-wrap: wrap;
      position: absolute;
      bottom: 40px;
      overflow-x: hidden;
      top: 120px;
      right: 0;
      left: 0;
      box-sizing: border-box;

      /**空白展示 */
      &.blank{
        font-size: 25px;
        font-weight: 600;
        width: 100%;
        position: absolute;
        text-align: center;
        vertical-align: middle;
        align-items: center;
        font-size: 45px;
        justify-content: center;
        display: flex;
      }

      .chart-wrap{
        width: 50%;
        padding: 10px;
        box-sizing: border-box;
      }
    }

    /**分页信息 */
    .el-pagination{
      position: absolute;
      bottom: 5px;
      right: 0;
    }

  }
  /**菜单栏 */
  .menu{
    background: #fff;
    padding:10px;

    /**菜单栏按钮 */
    .menu-btn {
      height: 40px;
      margin-right: 10px;
      span {
        font-size: 16px;
        font-weight: 400;
        cursor: pointer;
      }
    }
    .date-input{
      width:135px;
      input {
        width:130px;
        padding-right: 15px;
      }
    }
    .time-input{
      width:100px;
      input {
        width:90px;
        padding-right: 10px;
      }
    }
    /**时间范围 */
    .time_range{
      width:120px;
    }
    /**最大行数 */
    .maxrowcount{
      input{
        width: 100px;
        padding:0 0 0 5px;
      }

    }

    .el-form-item{
      margin-bottom: initial;
    }
  }
}
</style>